var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolbarAnnotate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_10_1",
    "data-name": "Component 10 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.133,
    height: 28.992,
    viewBox: "0 0 20.133 28.992",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M10.067,0A10.067,10.067,0,0,1,20.133,10.067c0,5.56-3.231,8.236-10.067,18.925C2.9,17.265,0,15.626,0,10.067A10.067,10.067,0,0,1,10.067,0Z",
    fill: "current"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 3.439,
    cy: 3.439,
    r: 3.439,
    transform: "translate(6.018 6.878)",
    fill: "#4a4a4a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarAnnotate);
export default __webpack_public_path__ + "static/media/toolbar-annotate.443edb4f7c705189ee35796103c2421b.svg";
export { ForwardRef as ReactComponent };